import { InvoiceSecondaryStatus } from '@features/invoices/enums/invoiceSecondaryStatus'
import { InvoiceStatus } from '@features/invoices/enums/invoiceStatus'
import { Invoice } from '@features/invoices/types/invoices/invoice'
import { hasInvoiceSentStatus } from '@features/invoices/utils/hasInvoiceSentStatus'

const invoiceSentStatuses: InvoiceStatus[] = [
  InvoiceStatus.Overdue,
  InvoiceStatus.Paid,
  InvoiceStatus.Reminded,
  InvoiceStatus.Sent,
]

export const isInvoiceAlreadySent = (invoice?: Invoice): boolean => {
  const statusInfo = invoice?.status

  if (!statusInfo) {
    return false
  }

  return (
    invoiceSentStatuses.includes(statusInfo.status) ||
    statusInfo.secondaryStatus === InvoiceSecondaryStatus.DELIVERED ||
    statusInfo.paidDate !== null ||
    hasInvoiceSentStatus(statusInfo.events)
  )
}
